<template lang="pug">
  .loading-page-container
    img.loading-icon(src="https://m.hellobike.com/0ba8c88f_Slice%2019.png")
    .loading-text 即将进入...
</template>

<script>
export default {
  name: 'PageTab',
  props: {
    points: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.loading-page-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: #fff;

  .loading-icon {
    width: 0.69rem;
    height: 0.56rem;
  }

  .loading-text {
    margin-top: 0.04rem;
    font-weight: 500;
    font-size: 0.12rem;
    line-height: 0.17rem;
    color: #879099;
  }
}
</style>
